/**
 * StoreRegistry — Singleton that tracks all Pinia stores and their reset callbacks.
 *
 * Each store registers itself at creation time by calling `storeRegistry.register(name, resetFn)`.
 * On logout, `storeRegistry.resetAll()` invokes every registered callback, eliminating the need
 * for `resetUser()` to manually enumerate stores.
 */
class StoreRegistry {
  private stores = new Map<string, () => void>()

  /** Register a store's reset callback. Overwrites any previous callback for the same name. */
  register(name: string, resetFn: () => void): void {
    this.stores.set(name, resetFn)
  }

  /** Call every registered reset callback. */
  resetAll(): void {
    for (const resetFn of this.stores.values()) {
      resetFn()
    }
  }

  /** Return the list of registered store names (useful for testing/debugging). */
  getRegisteredStores(): string[] {
    return Array.from(this.stores.keys())
  }

  /** Remove a store from the registry. */
  unregister(name: string): void {
    this.stores.delete(name)
  }
}

export const storeRegistry = new StoreRegistry()
